import { DialogActions, DialogContent, Grid, Stack } from "@mui/material";
import { MutationStatus } from "@tanstack/react-query";
import { Form as FormikForm, FormikProvider, useFormik } from "formik";
import { Link2, Save } from "lucide-react";
import React, { FC } from "react";
import * as yup from "yup";

// COMPONENTS:
import FormikTextField from "components/forms/FormikTextField";
import FormSection from "components/forms/FormSection";
import UltimateButton from "components/UltimateButton";

export type HubspotDealIdFormValues = {
  hubspotDealId: string;
};

interface IHubspotDealIdForm {
  handleSubmit: (values: HubspotDealIdFormValues) => void;
  handleClose: () => void;
  initialValues?: HubspotDealIdFormValues;
  submitStatus?: MutationStatus;
}

const HubspotDealIdForm: FC<IHubspotDealIdForm> = ({
  handleSubmit,
  handleClose,
  initialValues = {
    hubspotDealId: "",
  },
  submitStatus,
}) => {
  const schema = yup.object({
    hubspotDealId: yup.string().nullable().required(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: handleSubmit,
  });

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <FormSection
              title="HubSpot Deal"
              description="Update the HubSpot deal identifier."
              Icon={Link2}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikTextField
                    label="HubSpot Deal ID"
                    name="hubspotDealId"
                  />
                </Grid>
              </Grid>
            </FormSection>
          </Stack>
        </DialogContent>

        <DialogActions>
          <UltimateButton
            type="submit"
            text="Save"
            Icon={
              Save as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            loading={submitStatus === "loading"}
            sx={{
              minWidth: 150,
              py: 1.5,
            }}
          />
        </DialogActions>
      </FormikForm>
    </FormikProvider>
  );
};

export default HubspotDealIdForm;
